/** @format */

import { Button } from "primereact/button";
import React from "react";

import styles from "./Form5000properties.module.scss";

export default function Form5000properties() {
	return (
		<article className={styles.container}>
			<h3 className={styles.properties_title}>More than 5000 properties?</h3>
			<a href="https://www.inspectionmanager.com/contact-us/" target="_top">
				<Button className="btn btn-blue" label="Contact us" aria-label="Submit"></Button>
			</a>
		</article>
	);
}
